"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CreateMeter = class CreateMeter extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    item;
    async $$load_item() {
        return this.$fn.schemaDefaults('CreateMeter', { multiplier: 1 });
    }
    formName;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    submitAndClose;
    container;
    async $$load_container() {
        return {
            self: this.$fn.urlFor('create_meter'),
            object: 'list',
            data: []
        };
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['item', 'formName', 'formId', 'submitAndClose', 'container', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                formName: "meter",
                formId: null,
                submitAndClose: true,
                container: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    noPrimaryButton: true,
                    closeButtonText: this.$fn.gettext("Close"),
                    size: "md",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("Create Meter"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4874_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_4880_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1040167445267876_navigate_4882_getActionArgs($event) {
        return {
            location: {
                name: "app.meter",
                params: {
                    id: $event.data.response.data.id,
                },
            },
        };
    }
    async act_1040167445267876_reloadSlickgrid_4884_getActionArgs($event) {
        return {
            grid: "meters",
        };
    }
    async act_1040167445267876_rest_4878_getActionArgs($event) {
        return {
            method: "save",
            container: this.container,
            resource: this.item,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_script_4888_getActionArgs_value($event) {
        (this.setData('item', this.item.clone({
            id: null,
            rev: null,
            serial_number: null,
            links: null,
            etag: null,
            locked: null,
        })),
            this.setData('editor', this.item.editor()));
    }
    async act_1419464017721962_script_4888_getActionArgs($event) {
        return {
            value: () => this.act_1419464017721962_script_4888_getActionArgs_value($event),
        };
    }
    async act_1419464017721962_reloadSlickgrid_4890_getActionArgs($event) {
        return {
            grid: "meters",
        };
    }
    async act_1419464017721962_rest_4886_getActionArgs($event) {
        return {
            method: "save",
            container: this.container,
            resource: this.item,
        };
    }
    async evh_1419464017721962_click(event, scope) {
        return await this.actions.evh_1419464017721962_click.executeFromDOM(this, event, scope);
    }
    async evh_2186679009640457_clickPreventStop(event, scope) {
        return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4874 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4874_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4873 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4874,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4873],
        });
        const act_2248226175642056_closeComponent_4876 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_4875 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_4876,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_4875],
        });
        const act_1040167445267876_closeModal_4880 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_4880_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_4879 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_4880,
            event: "saved",
            displayName: "closeModal",
        });
        const act_1040167445267876_navigate_4882 = new core_1.actions.NavigateAction({
            actionArgs: this.act_1040167445267876_navigate_4882_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_4881 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_navigate_4882,
            event: "saved",
            displayName: "navigate",
        });
        const act_1040167445267876_reloadSlickgrid_4884 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1040167445267876_reloadSlickgrid_4884_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_4883 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_reloadSlickgrid_4884,
            event: "saved",
            displayName: "reloadSlickgrid",
        });
        const act_1040167445267876_rest_4878 = new core_1.actions.RestAction({
            actionArgs: this.act_1040167445267876_rest_4878_getActionArgs,
            displayName: "create",
            events: [evh_1040167445267876_saved_4879, evh_1040167445267876_saved_4881, evh_1040167445267876_saved_4883],
        });
        const evh_1040167445267876_submit_4877 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_rest_4878,
            event: "submit",
            displayName: "create",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_4877],
        });
        const act_1419464017721962_script_4888 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1419464017721962_script_4888_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_saved_4887 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_script_4888,
            event: "saved",
            displayName: "script",
        });
        const act_1419464017721962_reloadSlickgrid_4890 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1419464017721962_reloadSlickgrid_4890_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_saved_4889 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_reloadSlickgrid_4890,
            event: "saved",
            displayName: "reloadSlickgrid",
        });
        const act_1419464017721962_rest_4886 = new core_1.actions.RestAction({
            actionArgs: this.act_1419464017721962_rest_4886_getActionArgs,
            displayName: "create2",
            events: [evh_1419464017721962_saved_4887, evh_1419464017721962_saved_4889],
        });
        const evh_1419464017721962_click_4885 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_rest_4886,
            event: "click",
            displayName: "create2",
        });
        const evh_1419464017721962_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_click_4885],
        });
        const act_2186679009640457_closeComponent_4892 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2186679009640457_clickPreventStop_4891 = new core_1.actions.EventHandlerImpl({
            action: act_2186679009640457_closeComponent_4892,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_2186679009640457_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2186679009640457_clickPreventStop_4891],
        });
        return {
            act_7315092382398562_closeModal_4874,
            evh_7315092382398562_close_4873,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_4876,
            evh_2248226175642056_close_4875,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_4880,
            evh_1040167445267876_saved_4879,
            act_1040167445267876_navigate_4882,
            evh_1040167445267876_saved_4881,
            act_1040167445267876_reloadSlickgrid_4884,
            evh_1040167445267876_saved_4883,
            act_1040167445267876_rest_4878,
            evh_1040167445267876_submit_4877,
            evh_1040167445267876_submit,
            act_1419464017721962_script_4888,
            evh_1419464017721962_saved_4887,
            act_1419464017721962_reloadSlickgrid_4890,
            evh_1419464017721962_saved_4889,
            act_1419464017721962_rest_4886,
            evh_1419464017721962_click_4885,
            evh_1419464017721962_click,
            act_2186679009640457_closeComponent_4892,
            evh_2186679009640457_clickPreventStop_4891,
            evh_2186679009640457_clickPreventStop,
            create: act_1040167445267876_rest_4878,
            create2: act_1419464017721962_rest_4886,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], CreateMeter.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateMeter.prototype, "onSize", null);
CreateMeter = __decorate([
    (0, vue_property_decorator_1.Component)()
], CreateMeter);
exports.default = CreateMeter;
vue_property_decorator_1.Vue.component("CreateMeter", CreateMeter);
